import { FavyColumns } from "./FavyColumns";
import { ThemeContext } from "./ThemeContext";

export const FavyColumnsCoupon = (props) => (
	<ThemeContext.Provider value={{ rendersCoupon: true, ...props }}>
		<FavyColumns {...props} />
	</ThemeContext.Provider>
);
